<template>
  <div>
    <title1
      type="1"
      title="分时放电量时间分布"
      subTitle="Electric Port Overview"
    />
    <div style="width: 565px; height: 325px">
      <MyEcharts
        v-if="showcdata"
        :id="'zongdianlian1234gjidianjia1234'"
        :options="cdata"
      />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      //   labelOption: {
      //     show: true,
      //     position: "insideRight",
      //   },

      //   tooltipOption: {
      //     trigger: "item",
      //     axisPointer: {
      //       type: "shadow",
      //     },
      //     formatter:
      //       "一班<br />故障：10H 20%<br />运行：20H 20%<br />暂停：30H 20%<br />离线：25H 20%",
      //   },
      cdata: {
        //
        tooltip: {
          trigger: "axis",
        },
        legend: {
          itemWidth: 12,
          itemHeight: 8,
          data: ["尖", "峰", "平", "谷"],
        },
        xAxis: {
          data: ["10/14", "10/15", "10/16", "10/17", "10/18", "10/19", "10/20"],
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          name: "kWh  ",
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "尖",
            type: "bar",
            barWidth: 13,
            stack: "使用情况",
            data: [705, 720, 736, 710, 710, 720, 730],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FFCE51",
                  },
                  {
                    offset: 1,
                    color: "#2E4039",
                  },
                ]),
              },
            },
          },
          {
            name: "峰",
            type: "bar",
            stack: "使用情况",
            data: [505, 520, 536, 510, 510, 520, 535],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#0B4C5D", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#0C809D", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0DB9E5", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
          {
            name: "平",
            type: "bar",
            stack: "使用情况",
            data: [385, 392, 398, 395, 392, 390, 395],
            itemStyle: {
              normal: { color: "#FFFFFF" },
            },
          },
          {
            name: "谷",
            type: "bar",
            stack: "使用情况",
            data: [190, 196, 197, 195, 196, 197, 195],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#15F5C9", // 0% 处的颜色
                    },
                    {
                      offset: 0.6,
                      color: "#1E927C", // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#1B3633", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    getBattery24hours() {
      let params = {
        enCode: "chuneng-quanguo-fsfdlsjfb",
        "@energyId": localStorage.getItem('bigScreen::storedEnergyId') || "ES00001",
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "time1");
          if (res) {
            let data = [];
            let data2 = [];
            let data3 = [];
            let data4 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_date);
              data.push(item.j_discharge_elect);
              data2.push(item.f_discharge_elect);
              data3.push(item.p_discharge_elect);
              data4.push(item.g_discharge_elect);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.cdata.series[2].data = data3;
            this.cdata.series[3].data = data4;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  destroyed() {
    this.$bus.$off('bigScreen::storedEnergyId')
  },
  mounted() {
    this.$bus.$on("bigScreen::storedEnergyId", () => {
      this.getBattery24hours()
    });
    this.getBattery24hours()
  },
};
</script>

<style lang="scss" scoped>
</style>